import { CoinsProvider } from './../../providers/coins/coins';
import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { Select } from 'ionic-angular/components/select/select';
import { LoadingController } from 'ionic-angular';

/**
 * Generated class for the PricePickerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'price-picker',
  templateUrl: 'price-picker.html'
})
export class PricePickerComponent {
  @ViewChild('currencySelect') currencySelect: Select;

  @Output('change') change: EventEmitter<string> = new EventEmitter<string>();

  currency: string;

  selectOptions = {
    title: 'Quote Currency',
    subTitle: 'Select the currency you want data displayed in'
  }

  constructor(
    public CP: CoinsProvider,
    public loadingCtrl: LoadingController
  ) {
    this.currency = CP.getCurrency();
  }

  currencyChange(event: Event, currency: string){
    let loader = this.loadingCtrl.create({ content: 'Fetching new prices'});
    loader.present();
    this.CP.setCurrency(currency, loader);
    this.change.emit(currency);
  }

  openCurrencySelect(){
    this.currencySelect.open();
  }

  currencies = [
    'USD',
    'EUR',
    'GBP',
    'JPY',
    'BTC',
    'Satoshi',
    'ETH'
  ]
}



// WEBPACK FOOTER //
// ./src/components/price-picker/price-picker.ts